
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works/what-are-vcoins",
      function () {
        return require("private-next-pages/how-it-works/what-are-vcoins.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works/what-are-vcoins"])
      });
    }
  